import React from 'react';
import { cmToInchParts, type InchParts } from '../helper';
import './InchDisplay.scss';

type InchDisplayProps = {
  cm?: number | null;
  rounding?: 'nearest' | 'floor' | 'ceil';
  showUnit?: boolean;
};

const InchPartsSpan: React.FC<{ parts: InchParts }> = ({ parts }) => {
  if (!parts || !Number.isFinite(parts.whole)) return null;

  const { whole, quarter } = parts;

  if (!quarter) {
    return (
      <span className="inch-display">
        <span className="inch-display__whole">{whole}</span>
      </span>
    );
  }

  return (
    <span className="inch-display">
      <span className="inch-display__whole">{whole}</span>
      <span className="inch-display__pipe"></span>
      <span className="inch-display__fraction">{quarter}/4</span>
    </span>
  );
};

export const InchDisplay: React.FC<InchDisplayProps> = ({ cm, rounding = 'ceil', showUnit = true }) => {
  if (cm == null || !Number.isFinite(cm)) return null;

  const parts = cmToInchParts(cm, rounding);

  return (
    <span className="inch-display-wrap">
      <InchPartsSpan parts={parts} />
      {showUnit && <span className="inch-display__unit">inch</span>}
    </span>
  );
};
